// メニューの項目（GitHub だけ外部リンク）。この順番でメニューに並ぶ
const menu = [
  { label: 'Home', to: '/' },
  { label: 'Works', to: '/works' },
  { label: 'Career', to: '/career' },
  { label: 'GitHub', href: 'https://github.com/Izu-TABI' },
  { label: 'Contact', to: '/contact' },
]

export default menu
